// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { dateSchema } from "../commonSchemas";

export const path = "create-load";

export const createLoadParamsSchema = z.object({
    sourceStationId: z.string(),
    destinationStationId: z.string(),
    pickupStart: dateSchema.nullable(),
    pickupEnd: dateSchema.nullable(),
    deliveryStart: dateSchema.nullable(),
    deliveryEnd: dateSchema.nullable(),
    notes: z.string(),
    weight: z.number(),
    pieces: z.number(),
    bol: z.string().nullable(),
});




export type CreateLoadParams = z.infer<typeof createLoadParamsSchema>;




// vendor/create-load endpoint
export function createLoad(
  params: z.input<typeof createLoadParamsSchema>
): Promise<void> {
  return requestHandler(
    "vendor/create-load",
    params,
    undefined,
  );
}

